import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import swal from 'sweetalert2';
import { HttpService } from 'app/core/http/http.service';
import { NotificationService } from 'app/shared/utils/notification.service';
import { BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
@Component({
  selector: 'app-affecter-user',
  templateUrl: './affecter-user.component.html',
  styleUrls: ['./affecter-user.component.css']
})
export class AffecterUserComponent implements OnInit {

  // onClose: Subject<boolean> = new Subject<boolean>();
  // submitted = false;
  // emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  // createUpdateFormGroup:FormGroup;
  onClose: Subject<boolean> = new Subject<boolean>();
  searchUser: string;
  agence: Object;
  agences: Object[] = [];
  users: Object[] = [];
  agenceUsers: Object[] = [];
  allSelected = false;
  allAgenceUserSelected = false;
  @Input() userToUpdate;
  constructor(public httpService: HttpService, private notification: NotificationService, public modalRef: BsModalRef, private formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.onClose.next(false);
    this.agences = this.userToUpdate["agences"];
    this.users = this.userToUpdate["users"]/*.filter(user => !(user["AgenceID"]))*/.map(user => {
      user["selected"] = false
      return user;
    });
    console.log("users", this.users);


  }

  selectAllUser() {
    this.users.map(user => {
      user["selected"] = !this.allSelected
      return user;
    });
    this.allSelected = !this.allSelected
  }
  selectUser(user) {
    this.users.filter(utilisateur => utilisateur["ID"] === user["ID"]).map(utilisateur => {
      utilisateur["selected"] = !user["selected"]
      return utilisateur;
    });
    this.allSelected = this.users.length ? this.users.every(utilisateur => utilisateur["selected"]) : false;
  }

  selectAllAgenceUser() {
    this.agenceUsers.map(user => {
      user["selected"] = !this.allAgenceUserSelected
      return user;
    });
    this.allAgenceUserSelected = !this.allAgenceUserSelected
  }

  selectAgenceUser(user) {
    this.agenceUsers.filter(utilisateur => utilisateur["ID"] === user["ID"]).map(utilisateur => {
      utilisateur["selected"] = !user["selected"]
      return utilisateur;
    });
    this.allAgenceUserSelected = this.agenceUsers.length ? this.agenceUsers.every(utilisateur => utilisateur["selected"]) : false;
  }

  addUserToAffect() {
    if (this.agence && this.agence["ID"]) {
      if (this.users.some(utilisateur => utilisateur["selected"])) {

        this.users.filter(utilisateur => utilisateur["selected"]).map(utilisateur => {
          let temp = Object.assign({}, utilisateur);
          temp["AgenceID"] = this.agence["ID"];
          temp["AgenceNom"] = this.agence["Nom"];
          temp["selected"] = false;

          return temp;
        }).forEach(element => {
          this.agenceUsers.unshift(element);
        });
        this.users = this.users.filter(user => !user["selected"]);
        this.allSelected = this.users.length ? this.users.every(utilisateur => utilisateur["selected"]) : false;

      }
      else {
        //Veuillez selectionner les utilisateurs que vous souhaitez ajouter
        this.notification.smallBox({
          title: "Oops !",
          content: "Veuillez selectionner les utilisateurs que vous souhaitez ajouter",
          color: "rgb(159,0,6)",
          timeout: 6000,
          icon: "fa fa-close"
      });
      }
    }
    else {
      this.notification.smallBox({
        title: "Oops !",
        content: "Veuillez selectionner une agence",
        color: "rgb(159,0,6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
    }
  }

  disableAjout(): boolean {
    return !(this.users.some(user => user["selected"]));
  }

  disableRetrait() {
    return !(this.agenceUsers.some(agenceUser => agenceUser["selected"]));
  }

  retireUser() {
    if (this.agenceUsers.some(agenceUser => agenceUser["selected"])) {
      this.agenceUsers.filter(agenceUser => agenceUser["selected"]).map(agenceUser => {
        let temp = Object.assign({}, agenceUser);

        temp["selected"] = false;
        delete temp["AgenceID"]
        delete temp["AgenceNom"]

        return temp;
      }).forEach(agenceUser => {
        this.users.unshift(agenceUser);
      });
      this.agenceUsers = this.agenceUsers.filter(agenceUser => !agenceUser["selected"]);
      this.allAgenceUserSelected = this.agenceUsers.length ? this.agenceUsers.every(utilisateur => utilisateur["selected"]) : false;

    }
    else {
      //Veuillez selectionner les utilisateurs que vous souhaitez retirer
      this.notification.smallBox({
        title: "Oops !",
        content: "Veuillez selectionner les utilisateurs que vous souhaitez retirer",
        color: "rgb(159,0,6)",
        timeout: 6000,
        icon: "fa fa-close"
    });

    }
  }
  affectationUsers() {
    let data = {
      "EnseigneUsers": this.agenceUsers
    }
    this.httpService.execute("updateManyEnseigneUser", data).subscribe(res => {
      //console.log('create abonne response', res);
      if (!res.HasError) {
        this.notification.smallBox({
          title: "Succès !",
          content: res.Data.nombreAffectationOK + " affecté(s) sur " + this.agenceUsers.length + " soumis",
          color: "#35a646",
          timeout: 6000,
          icon: "fa fa-check"
      });
        this.closeModal();
      } else {
        this.notification.smallBox({
          title: "Oops !",
          content: res.Message,
          color: "rgb(159,0,6)",
          timeout: 6000,
          icon: "fa fa-close"
      });
      }
    }, err => {
      this.notification.smallBox({
        title: "Oops !",
        content: err.Message,
        color: "rgb(159,0,6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
    })
  }
  closeModal() {
    this.modalRef.hide();
    this.onClose.next(true);
  }


}
